import React from 'react';
import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Priya & Rahul Sharma',
      event: 'Wedding Celebration',
      rating: 5,
      text: 'Made in Heaven made our dream wedding come true! From the stunning decor to flawless execution, every detail was perfect. The team was professional, creative, and made us feel stress-free throughout. Highly recommended!',
      location: 'Vadodara',
    },
    {
      name: 'Amit Patel',
      event: 'Corporate Annual Meet',
      rating: 5,
      text: 'We hired Made in Heaven for our company\'s annual conference, and they exceeded all expectations. The event was organized impeccably, and our guests were thoroughly impressed. Great team to work with!',
      location: 'Vadodara',
    },
    {
      name: 'Neha Desai',
      event: 'Birthday Party',
      rating: 5,
      text: 'The team transformed the venue into a magical space for my daughter\'s birthday party. The decorations were stunning, and the coordination was seamless. Everyone loved it! Thank you, Made in Heaven!',
      location: 'Vadodara',
    },
    {
      name: 'Vikram & Anjali Mehta',
      event: 'Engagement Ceremony',
      rating: 5,
      text: 'Outstanding service! Made in Heaven handled everything from decoration to catering. The attention to detail and creative ideas made our engagement ceremony truly memorable. Worth every penny!',
      location: 'Vadodara',
    },
    {
      name: 'Rajesh Kumar',
      event: 'Product Launch Event',
      rating: 5,
      text: 'Professional, reliable, and creative - that\'s Made in Heaven! They managed our product launch event brilliantly. The setup was impressive, and everything ran smoothly. Highly professional team!',
      location: 'Vadodara',
    },
    {
      name: 'Kavita Shah',
      event: '25th Anniversary',
      rating: 5,
      text: 'Made in Heaven helped us celebrate our 25th anniversary in the most beautiful way. The elegant decorations and perfect arrangements made it an unforgettable evening for us and our guests.',
      location: 'Vadodara',
    },
  ];

  return (
    <section id="testimonials" className="py-20 md:py-32 relative overflow-hidden">
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-fixed"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1558591710-4b4a1ae0f04d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3NzM3MTI0MzF8MA&ixlib=rb-4.1.0&q=85)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/95 to-gray-900/90"></div>
      </div>

      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-amber-400 font-semibold text-lg tracking-wide uppercase">
            Client Testimonials
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mt-4 mb-6">
            What Our Clients Say
          </h2>
          <p className="text-lg text-gray-300">
            Don't just take our word for it - hear from the happy clients we've had the pleasure of serving.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-md rounded-2xl p-8 hover:bg-white/15 transition-all duration-300 hover:scale-105 shadow-xl border border-white/20"
            >
              {/* Quote Icon */}
              <div className="text-amber-400 mb-4">
                <Quote size={40} />
              </div>

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={20} className="text-amber-400 fill-amber-400" />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-200 leading-relaxed mb-6 italic">
                "{testimonial.text}"
              </p>

              {/* Client Info */}
              <div className="border-t border-white/20 pt-4">
                <h4 className="text-white font-semibold text-lg mb-1">
                  {testimonial.name}
                </h4>
                <p className="text-amber-400 text-sm font-medium mb-1">
                  {testimonial.event}
                </p>
                <p className="text-gray-400 text-sm">
                  {testimonial.location}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-xl text-white mb-4">
            Ready to create your own success story?
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-amber-600 hover:bg-amber-700 text-white px-8 py-4 rounded-full font-semibold transition-all duration-300 hover:scale-105 shadow-xl"
          >
            Let's Plan Your Event
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
